// TopBar is now a thin wrapper that renders the simplified <AppHeader />
// AND the new <BottomTabBar />. Any page that already imports <TopBar />
// automatically gets both the header and the bottom nav.
//
// Note: <main> gets an automatic padding-bottom via global CSS so its
// content is never hidden behind the fixed 64px bottom bar.
import AppHeader from "@/components/AppHeader";
import BottomTabBar from "@/components/BottomTabBar";

export default function TopBar() {
  return (
    <>
      <AppHeader />
      <BottomTabBar />
    </>
  );
}
